import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ModalService } from '@philips-internal/oswald-ui-components';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { ResultTermCardAPI } from '@philips-emr/referring-physician-components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

@Controller({ fragment: 'profile-privacy-and-terms', component: 'layout-privacy-terms-profile' })
export default class ProfilePrivacyAndTermsController extends BaseController {

  @Inject('result-term-card-privacy')
  resultPrivacy: ResultTermCardAPI;

  @Inject('result-term-card-term')
  resultTerm: ResultTermCardAPI;

  @OnClick({ target: 'result-term-card-privacy' })
  onPrivacy(event: ClickEvent): void {
    const { termSeqNr } = event.value;
    this.onClickDeckPrivacy(termSeqNr);
  }

  @OnClick({ target: 'result-term-card-term' })
  onTermo(event: ClickEvent): void {
    const { termSeqNr } = event.value;
    this.onClickDeckTermOfUse(termSeqNr);
  }

  onClickDeckPrivacy(termSeqNr: number): void {
    ModalService.openFullscreen({
      closeable: true,
      fragment: 'privacy-modal',
      onClose: () => {return},
      title: 'newaccount.privacy',
      contextData: {
        termSeqNr
      }
    });
  }

  onClickDeckTermOfUse(termSeqNr: number): void {
    ModalService.openFullscreen({
      closeable: true,
      fragment: 'term-of-user-modal',
      onClose: () => {return},
      title: 'results.terms.use',
      contextData: {
        termSeqNr
      }
    });
  }

}
